import React from "react";
import { createPortal } from "react-dom";

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?", 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  type = "danger" // danger, warning, info
}) => {
  if (!isOpen) return null;

  const typeStyles = {
    danger: {
      iconBg: "bg-red-600/10 text-red-500",
      confirmBg: "bg-red-600 hover:bg-red-700",
      icon: "fas fa-exclamation-triangle"
    },
    warning: {
      iconBg: "bg-amber-500/10 text-amber-500",
      confirmBg: "bg-amber-500 hover:bg-amber-600",
      icon: "fas fa-exclamation-circle"
    },
    info: {
      iconBg: "bg-blue-500/10 text-blue-500",
      confirmBg: "bg-blue-500 hover:bg-blue-600",
      icon: "fas fa-info-circle"
    }
  };

  const style = typeStyles[type] || typeStyles.danger;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-sm rounded-3xl border border-[#222] bg-[#111] p-8 shadow-2xl animate-in fade-in zoom-in duration-200">
        <div className="flex flex-col items-center text-center">
          <div className={`mb-4 flex h-16 w-16 items-center justify-center rounded-2xl ${style.iconBg}`}>
            <i className={`${style.icon} text-2xl`} />
          </div>
          <h3 className="mb-2 text-xl font-bold text-white font-['Prata',serif]">{title}</h3>
          <p className="mb-8 text-sm text-[#888]">
            {message}
          </p>
          <div className="flex w-full flex-col gap-3">
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className={`w-full rounded-xl py-3.5 font-bold text-white transition active:scale-[.98] ${style.confirmBg}`}
            >
              {confirmText}
            </button>
            <button
              onClick={onClose}
              className="w-full rounded-xl border border-[#222] bg-[#1a1a1a] py-3.5 font-bold text-[#888] transition hover:border-[#333] hover:text-white"
            >
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;
